export { default } from './PageMainLayout';



// WEBPACK FOOTER //
// ./src/components/PageMainLayout/index.js